import useAppTranslation from "@hooks/language/useAppTranslation";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import img1 from "../assets/saveSettings_1.webp";
import img2 from "../assets/saveSettings_2.webp";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterDiscordLink from "../components/HelpCenterDiscordLink";
import HelpCenterImage from "../components/HelpCenterImage";
import HelpCenterText from "../components/HelpCenterText";
import HelpCenterTitle from "../components/HelpCenterTitle";

const HowToSaveSettings = () => {
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <>
      <SEO
        title={t("saveSettings.seo.title")}
        description={t("saveSettings.seo.description")}
      />
      <HelpCenterContainer title={t("saveSettings.title")}>
        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.saveSettings.intro">
            Lorsque vous jouez à League of Legends sur plusieurs comptes, aussi
            appelés "smurfs", il peut être fastidieux de configurer manuellement
            vos paramètres préférés sur chacun d'eux. Heureusement, Il a une
            solution pour sauvegarder et synchroniser vos paramètres de jeu,
            vous permettant de maintenir une expérience de jeu cohérente sur
            tous vos comptes. Ce guide vous expliquera comment sauvegarder et
            appliquer vos paramètres sur tous vos smurfs.
            <br />
            <br />
            Si vous utilisez des paramètres différents pour différents
            champions, nous ne recommandons pas de faire cela.
          </Trans>
        </HelpCenterText>

        <HelpCenterTitle>{t("saveSettings.step1.title")}</HelpCenterTitle>

        <HelpCenterText>{t("saveSettings.step1.text")}</HelpCenterText>

        <HelpCenterImage src={img1} />

        <HelpCenterTitle>{t("saveSettings.step2.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.saveSettings.step2.text">
            Allez dans le dossier League of Legends, qui se trouve généralement
            dans <strong>[C:\Riot Games\League of Legends]</strong>, sauf si
            vous avez modifié le chemin de téléchargement.
          </Trans>
          <ul>
            <li>{t("saveSettings.step2.list.item1")}</li>
            <li>{t("saveSettings.step2.list.item2")}</li>
            <li>{t("saveSettings.step2.list.item3")}</li>
          </ul>
        </HelpCenterText>
        <HelpCenterImage src={img2} />
        <HelpCenterTitle>{t("common.conclusion")}</HelpCenterTitle>
        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.saveSettings.conclusion.text">
            La sauvegarde et la synchronisation de vos paramètres sur tous vos
            smurfs est une méthode efficace pour assurer une expérience de jeu
            cohérente, quel que soit le compte que vous utilisez. En suivant ce
            guide, vous pouvez facilement synchroniser vos paramètres préférés
            sur plusieurs comptes, ce qui vous permet de vous concentrer sur le
            jeu plutôt que sur les réglages. Si vous rencontrez des problèmes ou
            avez des questions supplémentaires, n'hésitez pas à nous contacter
            via notre <HelpCenterDiscordLink />.
          </Trans>
        </HelpCenterText>
      </HelpCenterContainer>
    </>
  );
};

export default HowToSaveSettings;
